import styled, { css } from 'styled-components';
import { withSiteTheme } from '../../../../config/css';

const DocumentBrowseCardContentTheme = {
  default: css`
    display: block;

    .horizontal & {
      display: flex;
      align-items: center;
      padding-left: 1.6rem;
    }

    .no-image & {
      a {
        margin: 2px;
      }
    }

    .quick-view-card & {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 0;
    }
  `,
  cio: css`
    margin-top: 0.2rem;
  `,
};

const DocumentBrowseCardContent = styled.div.attrs({
  className: 'document-browse-card__content',
})`
  ${withSiteTheme(DocumentBrowseCardContentTheme)}
`;

export default DocumentBrowseCardContent;
